/**
 * Site1 Template Entry Point
 * Export the main template component and sample data
 */

import Site1Template from "./Site1Template";

export { buildSiteData } from "./mapSettings";

/**
 * Placeholder content for template pickers and previews only.
 *
 * This is NOT a fallback for a live page: every field here is owned by the
 * organization and comes from BookingPageSettings. A live page renders whatever
 * the backoffice supplies and omits the rest, so a visitor never reads copy
 * that was written for a different business.
 *
 * `imageUrl` is intentionally null — the hero paints a wash of the brand colour
 * when no header image is set, so the template ships no stock photography.
 */
export const sampleData = {
  logo: null,
  businessName: "Your business",
  menuItems: [
    { label: "About", href: "#about" },
    { label: "Contact", href: "#contact" },
  ],
  colors: { primary: "#5c9f24", secondary: "#1a1d19" },
  hero: {
    title: "Your business name",
    description: "A short line about what you do.",
    imageUrl: null,
    buttonText: "Book an appointment",
  },
  about: {
    title: "About us",
    label: "About us",
    text: "Tell visitors who you are and what makes your service worth booking.",
  },
  contact: {
    address: "Your street 1, Your city",
    phone: "+40 700 000 000",
    email: "hello@example.com",
    openingHours: "Mon–Fri: 09:00–18:00\nSat: 10:00–14:00\nSun: closed",
  },
  social: {},
};

export default Site1Template;
